export default "<app-data-deployments-map *ngIf=\"deployments\" [deployments]=\"deployments\"></app-data-deployments-map>"